/**
 * The one choice some agent skills need before they can be created, made on
 * their card in step 3 (e.g. "Enviar contrato" needs the ZapSign contract
 * models). The base skill is answered in step 4 and is not handled here.
 */

const CHOICE_TYPES = new Set(["multiEnum", "enum"]);

/** First required choice field with real options, or null. */
export function choiceField(skill) {
  return (skill?.fields || []).find((f) => f.required && CHOICE_TYPES.has(f.type) && Array.isArray(f.options)) || null;
}

export function isChosen(field, value) {
  if (field.type === "multiEnum") return Array.isArray(value) && value.length >= (field.min || 1);
  return value !== null && value !== undefined && value !== "";
}

/** With a single option there is nothing to ask: it is picked. */
export function withDefaultChoice(skill, values) {
  const field = choiceField(skill);
  if (!field || isChosen(field, values[field.name]) || field.options.length !== 1) return values;
  const only = field.options[0].value;
  return { ...values, [field.name]: field.type === "multiEnum" ? [only] : only };
}

/** Skills that are on and still miss their choice, in card order. */
export function missingChoices(skills, enabled, valuesById) {
  return skills
    .filter((s) => s.kind === "agent" && !s.required && enabled[s.id])
    .map((s) => ({ skill: s, field: choiceField(s) }))
    .filter(({ skill, field }) => field && !isChosen(field, valuesById[skill.id]?.[field.name]))
    .map(({ skill }) => skill.id);
}

/** "Contrato de honorários, Procuração" for the card footer. */
export function choiceSummary(field, value) {
  const chosen = Array.isArray(value) ? value : value ? [value] : [];
  const byValue = new Map(field.options.map((o) => [o.value, o.label]));
  return chosen.map((v) => byValue.get(v) || v).join(", ");
}
